import { useStyles } from "pages/Schedule/styles";
import { useState, useEffect } from "react";
import { CalendarData } from "types/DaHome";
import { ScheduleReport } from "types/Schedule";

export const useScheduleCellTheme = (report: ScheduleReport | CalendarData | undefined) => {
  const classes = useStyles();
  const [theme, setTheme] = useState({
    colorClass: "",
    backgroundClass: "",
  });

  useEffect(() => {
    if (report?.is_available) {
      switch (report?.role) {
        case null:
          setTheme({
            colorClass: classes.greenColor,
            backgroundClass: classes.availableTheme,
          });
          break;
        case 0:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.standardTheme,
          });
          break;
        case 1:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.abscentTheme,
          });
          break;
        case 2:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.rescueTheme,
          });
          break;
        case 3:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.standbyTheme,
          });
          break;
        case 4:
          setTheme({
            colorClass: classes.blackColor,
            backgroundClass: classes.trainingTheme,
          });
          break;
        case 5:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.qualityTheme,
          });
          break;
        case 6:
          setTheme({
            colorClass: classes.blackColor,
            backgroundClass: classes.specialTheme,
          });
          break;
        case 7:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.mycuCancelledTheme,
          });
          break;
        case 15:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.clientCancelledTheme,
          });
          break;
        case 8:
          setTheme({
            colorClass: classes.blackColor,
            backgroundClass: classes.flexTheme,
          });
          break;
        case 9:
          setTheme({
            colorClass: classes.blackColor,
            backgroundClass: classes.dispatcherTheme,
          });
          break;
        case 10:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.supervisorTheme,
          });
          break;
        case 11:
          setTheme({
            colorClass: classes.blackColor,
            backgroundClass: classes.fleetCoordinatorTheme,
          });
          break;
        case 12:
          setTheme({
            colorClass: classes.blackColor,
            backgroundClass: classes.leadDriverTheme,
          });
          break;
        case 13:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.helperTheme,
          });
          break;
        case 14:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.supportDispatcherTheme,
          });
          break;
        case 17:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.performanceCoordinator,
          });
          break;
        case 16:
          setTheme({
            colorClass: classes.whiteColor,
            backgroundClass: classes.rejectedTheme,
          });
          break;
      }
    } else {
      setTheme({
        colorClass: classes.grayColor,
        backgroundClass: classes.unavailableTheme,
      });
    }
  }, [
    classes.greenColor,
    classes.grayColor,
    classes.blackColor,
    classes.whiteColor,
    classes.unavailableTheme,
    classes.availableTheme,
    classes.standardTheme,
    classes.abscentTheme,
    classes.rescueTheme,
    classes.standbyTheme,
    classes.trainingTheme,
    classes.qualityTheme,
    classes.specialTheme,
    classes.mycuCancelledTheme,
    classes.flexTheme,
    classes.dispatcherTheme,
    classes.supervisorTheme,
    classes.fleetCoordinatorTheme,
    classes.leadDriverTheme,
    classes.helperTheme,
    classes.rejectedTheme,
    classes.supportDispatcherTheme,
    classes.performanceCoordinator,
    classes.clientCancelledTheme,
    report?.role,
    report,
  ]);

  return {
    theme,
  };
};
